import React, { useContext, useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  FormControl,
  Select,
  MenuItem,
  Button,
  Box,
  IconButton,
  useMediaQuery,
} from '@mui/material';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import { poppins300, poppins400, poppins500 } from 'theme/common.style';
import { Divider } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { InputAdornment } from '@mui/material';
import { useTheme } from '@emotion/react';
import { CANCEL_FLOW, MOVETO_SETTLEMENT } from 'constant/app.config';
import { datacontext } from 'modules/AppLayout/AppLayout';
import { postApiCall } from 'api/apiService';
import Swal from 'sweetalert2';
import { PropertyContext } from 'component/PropertyContext/PropertyContext';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export default function SettlementStatusDialog({
  open,
  onClose,
  propertyId,
  buyerId,
  profileDetails,
  propAddress,
  publishcard,
  unpublishcard,
  setOpenPublishWinnerBox,
  from,
}) {
  const theme = useTheme();
  const matches450 = useMediaQuery(theme.breakpoints.down(450));
  const [status, setStatus] = useState('');
  const [alternateWinner, setAlternateWinner] = useState(true);
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [openDatePicker, setOpenDatePicker] = useState(false);
  const minDate = dayjs().tz('Australia/Sydney').add(1, 'day');
  const [dateError, setDateError] = useState(false);
  const { bannerApiTrigger } = useContext(datacontext);

  useEffect(() => {
    if (!profileDetails) return;

    if (profileDetails?.buyerTotalCount <= 1) {
      setAlternateWinner(false);
    }
  }, [profileDetails?.buyerTotalCount]);

  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));

  // const [openpublishwinnerbox, setOpenPublishWinnerBox] = useState(false);
  const [openSelectBuyer, setOpenSelectBuyer] = useState(false);
  const [selectedBuyer, setSelectedBuyer] = useState();

  const history = useHistory();

  const normalizeAmount = (value) =>
    Number(String(value).replace(/[^0-9.]/g, ''));
  let depositAmount =
    from === 'dashboard'
      ? profileDetails?.isWinnerDepositAmount
      : profileDetails?.PropertyDetails?.isWinnerDepositAmount;

  let price =
    from === 'dashboard'
      ? profileDetails?.winningOffer
      : profileDetails?.PropertyDetails?.winningOffer;

  const normalizedDeposit = normalizeAmount(depositAmount);
  const normalizedPrice = normalizeAmount(price);

  const handleClose = async () => {
    if (from == 'dashboard' && normalizedDeposit != normalizedPrice) {
      onClose();
      return;
    }

    setStatus('');
    setDateError('');
    setSelectedDate(minDate);
    const params = {
      propertyId: propertyId,
      buyerId: buyerId,
      action: 'Settlement',
      //  "noOfMin":60,
    };
    try {
      const res = await postApiCall(CANCEL_FLOW, params);
      if (res.data?.status == -1) {
        Swal.fire({
          title: res?.data?.heading,
          text: res?.data?.message,
          icon: 'error',
          confirmButtonText: 'Close',
        });
      } else {
        Swal.fire({
          title: res?.data?.heading,
          text: res?.data?.message,
          icon: 'success',
          confirmButtonText: 'Close',
        }).then(() => {
          if (typeof publishcard === 'function') {
            publishcard();
          }

          if (typeof unpublishcard === 'function') {
            unpublishcard();
          }
        });
      }
    } catch (err) {
      console.error(err);
    }
    onClose();
  };

  //  states to open request deposit dialog
  const [depositRes, setDepositRes] = useState('');

  useEffect(() => {
    setDepositRes(selectedBuyer?.buyerOfferDetails?.depositPaymentLog);
  }, [selectedBuyer]);

  const handleSubmit = async () => {
    let hasError = false;

    // Validation: If "No" is selected and reason is not chosen
    if (!alternateWinner && !status) {
      setStatusError(true);
      hasError = true;
    } else {
      setStatusError(false);
    }

    if (hasError) return;

    if (alternateWinner) {
      if (from === 'dashboard') {
        history.push({
          pathname: `/dashboard/view-dashboard/${propertyId}`,
          state: { fromDashBoard: true },
        });
        return;
      }
      setOpenPublishWinnerBox(true);
      onClose();
      return;
    }

    const dat = dayjs(selectedDate);
    const formattedDate = dat.format('YYYY-MM-DD');
    const params = {
      propertyId: propertyId,
      buyerId: buyerId,
      reasonForDelay: status,
      isSettlement: 0,
      extendedTime:
        status === 'Both parties agreed to extend Settlement'
          ? formattedDate
          : '',
      action: 'Settlement',
    };
    try {
      const res = await postApiCall(MOVETO_SETTLEMENT, params);
      bannerApiTrigger();
      if (res.data?.status !== 1) {
        Swal.fire({
          title: res?.data?.heading,
          text: res?.data?.message,
          icon: 'error',
          confirmButtonText: 'Close',
        });
      } else {
        Swal.fire({
          title: res?.data?.heading,
          text: res?.data?.message,
          icon: 'success',
          confirmButtonText: 'Close',
        }).then(() => {
          if (typeof publishcard === 'function') publishcard();
          if (typeof unpublishcard === 'function') unpublishcard();
        });
      }
    } catch (err) {
      console.error(err);
    }
    onClose();
  };

  const Pendingwarning = () => {
    return (
      <svg
        width="38"
        height="36"
        viewBox="0 0 38 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          width="37.5797"
          height="36"
          rx="18"
          fill="#F39800"
          fill-opacity="0.1"
        />
        <path
          d="M27.0817 21.4607L21.3085 11.456C20.7883 10.5551 19.8271 10 18.7866 10C17.7462 10 16.7851 10.5551 16.2648 11.456L10.3902 21.632C9.86994 22.5329 9.86994 23.6431 10.3902 24.544C10.9104 25.4449 11.8715 26 12.912 26H24.6614C24.6646 26 24.6677 26 24.6677 26C26.276 26 27.5797 24.6962 27.5797 23.088C27.5797 22.4853 27.3957 21.9239 27.0817 21.4607ZM20.0333 22.4345C20.0333 23.1229 19.5036 23.6495 18.7898 23.6495C18.0761 23.6495 17.5464 23.1229 17.5464 22.4345V22.406C17.5464 21.7208 18.0761 21.1911 18.7898 21.1911C19.5036 21.1911 20.0333 21.7177 20.0333 22.406V22.4345ZM20.0619 14.2443L19.4465 19.6178C19.4052 20.0048 19.1483 20.2458 18.7898 20.2458C18.4314 20.2458 18.1745 20.0016 18.1332 19.6178L17.5178 14.2411C17.4766 13.8255 17.7019 13.5115 18.0888 13.5115H19.4877C19.8747 13.5147 20.1031 13.8287 20.0619 14.2443Z"
          fill="#F39800"
        />
      </svg>
    );
  };
  const ToggleOn = () => (
    <svg
      width="42"
      height="25"
      viewBox="0 0 42 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.460938"
        width="41.54"
        height="24.3705"
        rx="12.1852"
        fill="url(#paint0_linear)"
      />
      <ellipse
        cx="12.981"
        cy="12.1852"
        rx="8.52103"
        ry="8.86199"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="12.7341"
          y1="-1.66162"
          x2="18.2578"
          y2="28.3495"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6C2AD2" />
          <stop offset="1" stopColor="#77CFFE" />
        </linearGradient>
      </defs>
    </svg>
  );

  const ToggleOff = () => (
    <svg
      width="42"
      height="25"
      viewBox="0 0 42 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.459961"
        y="0.370483"
        width="41.54"
        height="24.3705"
        rx="12.1852"
        fill="#DFDFDF"
      />
      <ellipse
        cx="30.0913"
        cy="12.5557"
        rx="8.52103"
        ry="8.86199"
        fill="white"
      />
    </svg>
  );

  const Calenderselect = () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7 4.43245C7 4.27684 7 4.19903 6.9491 4.15423C6.89819 4.10944 6.82244 4.11915 6.67094 4.13857C5.54965 4.28229 4.76806 4.57508 4.17157 5.17157C3 6.34315 3 8.22876 3 12C3 15.7712 3 17.6569 4.17157 18.8284C5.34315 20 7.22876 20 11 20H13C16.7712 20 18.6569 20 19.8284 18.8284C21 17.6569 21 15.7712 21 12C21 8.22876 21 6.34315 19.8284 5.17157C19.2319 4.57508 18.4504 4.28229 17.3291 4.13857C17.1776 4.11915 17.1018 4.10944 17.0509 4.15424C17 4.19903 17 4.27684 17 4.43245L17 6.5C17 7.32843 16.3284 8 15.5 8C14.6716 8 14 7.32843 14 6.5L14 4.30005C14 4.15898 14 4.08844 13.9561 4.04451C13.9123 4.00059 13.8418 4.0005 13.7009 4.00031C13.4748 4 13.2412 4 13 4H11C10.7588 4 10.5252 4 10.2991 4.00031C10.1582 4.0005 10.0877 4.00059 10.0439 4.04452C10 4.08844 10 4.15898 10 4.30005L10 6.5C10 7.32843 9.32843 8 8.50001 8C7.67158 8 7 7.32843 7 6.5L7 4.43245Z"
        fill="#6D6868"
        fill-opacity="0.54"
      />
      <path d="M8.5 2.5L8.5 6.5" stroke="white" stroke-linecap="round" />
      <path d="M15.5 2.5L15.5 6.5" stroke="white" stroke-linecap="round" />
      <circle cx="7.5" cy="10.5" r="0.5" fill="white" />
      <circle cx="10.5" cy="10.5" r="0.5" fill="white" />
      <circle cx="13.5" cy="10.5" r="0.5" fill="white" />
      <circle cx="16.5" cy="10.5" r="0.5" fill="white" />
      <circle cx="7.5" cy="13.5" r="0.5" fill="white" />
      <circle cx="10.5" cy="13.5" r="0.5" fill="white" />
      <circle cx="13.5" cy="13.5" r="0.5" fill="white" />
      <circle cx="16.5" cy="13.5" r="0.5" fill="white" />
      <circle cx="7.5" cy="16.5" r="0.5" fill="white" />
      <circle cx="10.5" cy="16.5" r="0.5" fill="white" />
      <circle cx="13.5" cy="16.5" r="0.5" fill="white" />
      <circle cx="16.5" cy="16.5" r="0.5" fill="white" />
    </svg>
  );
  const [statusError, setStatusError] = useState(false);

  return (
    <>
      <Dialog
        open={open}
        // onClose={onClose}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick') {
            onClose();
          }
        }}
        maxWidth="sm"
        fullWidth
        fullScreen={matches450}
        PaperProps={{
          sx: {
            height: matches450 ? '500px' : 'auto',
          },
        }}
      >
        <DialogTitle>
          <Box>
            <Typography
              sx={{
                ...poppins400,
                fontSize: '14px',
                color: '#666666',
              }}
            >
              {propAddress}
            </Typography>
          </Box>
          <Box display="flex" alignItems="center" gap={1} mt={1}>
            <Pendingwarning />
            <Typography
              sx={{ ...poppins500, color: '#000000', fontSize: '24px' }}
            >
              Settlement Status Update
            </Typography>
          </Box>
          <Typography
            sx={{
              ...poppins400,
              fontSize: '16px',
              color: '#666666',
            }}
            mt={4}
          >
            Please update current settlement status.
          </Typography>
        </DialogTitle>
        <Divider sx={{ my: 2, mx: -3 }} />
        <DialogContent sx={{ pt: 2 }}>
          <Typography
            sx={{
              ...poppins400,
              fontSize: '16px',
              color: '#666666',
            }}
            mb={1}
          >
            Status
          </Typography>
          <FormControl fullWidth size="small" sx={{ pl: 1, mt: 1 }}>
            <Select
              value={status}
              onChange={(e) => {
                setStatus(e.target.value);
                if (statusError) setStatusError(false); // Clear error when user selects
              }}
              displayEmpty
              IconComponent={KeyboardArrowDownRoundedIcon}
              MenuProps={{
                PaperProps: {
                  sx: {
                    maxWidth: matches450 ? '50px' : 'none',
                    width: 'auto',
                    '& .MuiList-root': {
                      maxHeight: 150,
                      overflowY: 'auto',
                    },
                    '& .MuiMenuItem-root': {
                      whiteSpace: 'normal',
                      wordBreak: 'break-word',
                    },
                  },
                },
              }}
              sx={{
                borderRadius: 1,
                ...poppins300,
                fontWeight: 400,
                fontSize: '16px',
                color: status ? '#000' : '#666666', // Darken text only when selected
                '& .MuiOutlinedInput-notchedOutline': {
                  border: 'none',
                },
                border: `1px solid ${
                  statusError ? '#f44336' : status ? '#0055FFA3' : '#D9D9D9'
                }`,
                '& .MuiSelect-icon': {
                  fontSize: '1.4rem',
                  right: 10,
                },
              }}
              renderValue={(selected) => {
                if (!selected) {
                  return (
                    <span style={{ color: '#666666' }}>
                      Select the reason for delay
                    </span>
                  );
                }
                return selected;
              }}
            >
              <MenuItem value="Both parties agreed to extend Settlement">
                Both parties agreed to extend Settlement
              </MenuItem>
              <MenuItem value="Buyer has failed to complete settlement">
                Buyer has failed to complete settlement
              </MenuItem>
              <MenuItem value="Buyer looking to rescind">
                Buyer looking to rescind
              </MenuItem>
              <MenuItem value="Vendor looking to rescind">
                Vendor looking to rescind
              </MenuItem>
              <MenuItem value="Other reason">Other reason</MenuItem>
            </Select>
          </FormControl>

          {statusError && (
            <Typography
              sx={{
                ...poppins400,
                fontSize: '14px',
                color: '#f44336',
                mt: 0.5,
                pl: 1,
              }}
            >
              Please select the reason
            </Typography>
          )}

          {status == 'Both parties agreed to extend Settlement' && (
            <Box
              mt={3}
              gap={2}
              display={'flex'}
              justifyContent={'flex-start'}
              alignItems={'center'}
            >
              <Typography
                sx={{
                  ...poppins400,
                  fontSize: '16px',
                  color: '#666666',
                }}
              >
                {' '}
                Set new Settlement Date:
              </Typography>
              <Box sx={{ width: '330px' }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    value={selectedDate}
                    onChange={(newValue) => {
                      setSelectedDate(newValue);
                      if (newValue && newValue.isBefore(minDate, 'day')) {
                        setDateError(true);
                      } else {
                        setDateError(false);
                      }
                    }}
                    format="DD MMMM YYYY"
                    open={openDatePicker}
                    onClose={() => setOpenDatePicker(false)}
                    onOpen={() => setOpenDatePicker(true)}
                    minDate={minDate}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        variant: 'outlined',
                        error: dateError,
                        helperText: dateError
                          ? 'Past dates are not allowed'
                          : '',
                        placeholder: 'Select date',
                        InputProps: {
                          disableUnderline: true,
                          startAdornment: (
                            <InputAdornment position="start">
                              <IconButton
                                onClick={() => setOpenDatePicker(true)}
                                edge="start"
                                sx={{ padding: 1 }}
                              >
                                <Calenderselect sx={{ color: '#666' }} />
                              </IconButton>
                            </InputAdornment>
                          ),
                          sx: {
                            height: '50px',
                            borderRadius: '8px',
                            '& .MuiOutlinedInput-notchedOutline': {
                              borderColor: selectedDate
                                ? '#0055FFA3'
                                : '#D9D9D9',
                            },
                            backgroundColor: '#fff',
                            px: 1.5,
                            '& input': {
                              fontFamily: 'Poppins, sans-serif',
                              fontWeight: 400,
                              fontSize: '16px',
                              color: '#666666',
                            },
                          },
                        },
                        inputProps: {
                          style: {
                            ...poppins400,
                            fontSize: '16px',
                            color: '#000000',
                          },
                        },
                      },
                    }}
                    slots={{ openPickerIcon: () => null }}
                  />
                </LocalizationProvider>
              </Box>
            </Box>
          )}

          <Box mt={4}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: '16px',
                color: '#666666',
              }}
            >
              Would you like to nominate an alternate winner?
            </Typography>
            <Box
              mt={4}
              display="flex"
              alignItems="center"
              gap={2}
              onClick={() => {
                if (profileDetails?.buyerTotalCount >= 2) {
                  setAlternateWinner((prev) => !prev);
                }
              }}
              sx={{
                cursor:
                  profileDetails?.buyerTotalCount >= 2
                    ? 'pointer'
                    : 'not-allowed',
                pl: 2,
                opacity: profileDetails?.buyerTotalCount >= 2 ? 1 : 0.5,
                pointerEvents:
                  profileDetails?.buyerTotalCount >= 2 ? 'auto' : 'none',
              }}
            >
              <Typography
                sx={{ ...poppins400, fontSize: '12px', color: '#666666' }}
              >
                Yes
              </Typography>
              {alternateWinner ? <ToggleOn /> : <ToggleOff />}
              <Typography
                sx={{ ...poppins400, fontSize: '12px', color: '#666666' }}
              >
                No
              </Typography>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions
          sx={{
            pb: 2,
            px: 3,
            justifyContent: 'flex-end',
          }}
        >
          <Button
            onClick={handleClose}
            variant="outlined"
            sx={{
              padding: matchessm ? '6px 30px' : '10px 50px',
              height: matchessm ? '35px' : '41px',
              fontSize: matchessm ? '12px' : '15px',
              fontWeight: '400',
              borderRadius: '5px',
              textTransform: 'none',
              bgcolor: '#fff',
              borderColor: '#1123471A',
              color: '#666666',
              '&:hover': {
                bgcolor: '#fff',
                borderColor: '#1123471A',
              },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            disabled={dateError || false}
            sx={{
              padding: matchessm ? '6px 30px' : '10px 50px',
              height: matchessm ? '35px' : '41px',
              fontSize: matchessm ? '12px' : '15px',
              color: '#FFFFFF',
              fontWeight: '400',
              backgroundColor: '#4CA4D6',
              borderRadius: '5px',
              textTransform: 'none',
              '&:hover': { backgroundColor: '#4CA4D6' },
              '&.Mui-disabled': {
                backgroundColor: '#4CA4D6',
                color: '#fff',
                opacity: 0.7,
                cursor: 'not-allowed',
                pointerEvents: 'auto',
              },
            }}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
